import React from 'react';
import classNames from 'classnames';
import { reportClick } from '../../lib/reportEvent';

export default function ViewAllLink({
    desktop,
    mobile = false,
    href,
    text,
    categoryId,
    categoryName,
    subCategoryId,
    subCategoryName,
    title,
    position,
    pageCtxId
}) {
    const linkClassNames = classNames('cat-link', { 'is-mobile': mobile }, { 'is-desktop': desktop });

    const eventData = {
        categoryId,
        categoryName,
        subCategoryId,
        subCategoryName,
        title,
        position,
        pageCtxId
    };

    return (
        <a href={href}
            onClick={() => reportClick('pro_sub_category_carousel', eventData)}
            className={linkClassNames}>
            {text}
        </a>
    );
}



// WEBPACK FOOTER //
// ./src/common/HomePage/Gigs/ViewAllLink/index.js